import protobuf from "protobufjs";
import protoSchema from "./locations.proto?raw";

let root = null;

const loadRoot = () => {
    if (!root) {
        root = protobuf.parse(protoSchema).root;
    }

    return root;
};

const str = (value) => (value === null || value === undefined ? "" : String(value));

const toBytes = async (buffer) => {
    if (buffer instanceof ArrayBuffer) return new Uint8Array(buffer);
    if (ArrayBuffer.isView(buffer)) return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    if (typeof Blob !== "undefined" && buffer instanceof Blob) return new Uint8Array(await buffer.arrayBuffer());

    return null;
};

const decodeMetro = (raw = {}) => ({
    _id: str(raw.id),
    name: raw.name || "",
    parentId: raw.parentId || "",
    parentType: raw.parentType || "",
});

const decodeCity = (raw = {}) => ({
    _id: str(raw.id),
    area: raw.area || "",
    city: raw.city || "",
    regionId: raw.regionId || "",
    metro: Array.isArray(raw.metro) ? raw.metro.map(decodeMetro) : [],
});

const decodeRegion = (raw = {}) => ({
    _id: str(raw.id),
    name: raw.name || "",
    type: raw.type || "",
    name_with_type: raw.nameWithType || "",
    cities: Array.isArray(raw.cities) ? raw.cities.map(decodeCity) : [],
    metro: Array.isArray(raw.metro) ? raw.metro.map(decodeMetro) : [],
});

const decodeLocationsResponse = async (buffer) => {
    const bytes = await toBytes(buffer);
    if (!bytes || bytes.byteLength === 0) {
        return { success: false, errorCode: 0, msg: "Empty proto buffer" };
    }

    const Response = loadRoot().lookupType("rispromo.locations.LocationsResponse");
    const message = Response.decode(bytes);
    const obj = Response.toObject(message, {
        arrays: true,
        defaults: true,
        longs: String,
    });

    return {
        success: true,
        data: Array.isArray(obj.regions) ? obj.regions.map(decodeRegion) : [],
    };
};

export { decodeLocationsResponse };
